module.exports = __webpack_public_path__ + "static/img/Store-1.c4e8a630.png";